import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaPinterestP,
  FaLinkedin,
  FaInstagram,
  FaVimeoV,
  FaDribbble,
  FaBehance,
  FaEnvelopeOpen,
  FaTiktok,
  FaPhoneAlt,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import ServiceData from "../../data/service/ServiceMain.json";
import { slugify } from "../../utils";
import FooterLogo from "../../elements/footer-logo/FooterLogo";
import { MdEmail, MdPhoneInTalk } from "react-icons/md";
import { Globe, MapPinHouse } from "lucide-react";
import CtaLayoutOne from "../../component/cta/CtaLayoutOne";
const getServiceData = ServiceData;

const FooterOne = ({ parentClass }) => {
  const [iconSize, setIconSize] = useState(20); // Default size for `sm`

  useEffect(() => {
    const updateSize = () => {
      if (window.innerWidth >= 1200) {
        setIconSize(30); // `xl` size
      } else if (window.innerWidth >= 1024) {
        setIconSize(38); // `lg` size
      } else if (window.innerWidth >= 768) {
        setIconSize(22); // `md` size
      } else {
        setIconSize(27); // `sm` size
      }
    };

    updateSize(); // Initial check
    window.addEventListener("resize", updateSize); // Update on resize

    return () => {
      window.removeEventListener("resize", updateSize); // Cleanup listener
    };
  }, []);
  return (
    <>
      <CtaLayoutOne />
      <footer className={`footer-area ${parentClass}`}>
        <div className="container">
          <div className="footer-main">
            <div className="row">
              <div className="col-xl-5 col-lg-5 border-end">
                <div className="footer-widget1 ">
                  <div className="footer-newsletter">
                    <FooterLogo image="/images/ucwf-logo-footer.png" />
                    <h6 className="title">UCWF Facilites Management LLC</h6>
                    <p className="">
                      UCWF Provides Cost-Effective Facilities Management Service
                      With 24/7 Support, Ensuring Your Building Stays In Top
                      Condition
                    </p>
                    {/* <div className="d-flex"> */}
                    {/* <ul className="d-flex " style={{ flexDirection: "column" }}> */}
                    <span style={{ display: "flex", flexDirection: "column" }}>
                      <li className="d-inline-flex phone-item">
                        <MdPhoneInTalk className="icon-right" />
                        <a href="tel:800-8293(800 UCWF)">800 8293 (800 UCWF)</a>
                      </li>
                      <li className="d-inline-flex phone-item">
                        <FaPhoneAlt className="icon-right" size={15} />
                        <a href="tel:+971 44357619">+971 44357619</a>
                      </li>
                      <li className="d-inline-flex">
                        <MdEmail className="icon-right" size={20} />
                        <a href="mailto:info@ucwf.net">info@ucwf.net</a>
                      </li>
                    </span>

                    {/* </ul> */}
                    {/* </div> */}
                    {/* <div className="footer-contact">
                    <iframe
                      frameBorder="0"
                      scrolling="no"
                      allowTransparency="true"
                      width="250"
                      height="120"
                      src="https://cdn.yoshki.com/badge-bics.html"
                      style={{
                        border: "0px",
                        margin: "0px",
                        padding: "0px",
                        backgroundColor: "transparent",
                      }}
                      title="BICSC Digital Badge"
                    ></iframe>
                  </div> */}
                    {/* <form>
                                        <div className="input-group">
                                            <span className="mail-icon"><FaEnvelopeOpen /> </span>
                                            <input type="email" className="form-control" placeholder="Email address" />
                                            <button className="subscribe-btn" type="submit">Subscribe</button>
                                        </div>
                                    </form> */}
                  </div>
                </div>
              </div>
              <div className="col-xl-7 col-lg-7 ">
                <div className="row1 d-lg-flex justify-content-lg-evenly">
                  {/*   */}
                  <div className="col-sm-4">
                    <div className="footer-widget">
                      <h6 className="widget-title">
                        <Link to={process.env.PUBLIC_URL + "/who-we-are"}>
                          About us
                        </Link>
                      </h6>
                      <div className="footer-menu-link">
                        <ul className="list-unstyled">
                          <li>
                            <Link to={process.env.PUBLIC_URL + "/who-we-are"}>
                              Who We Are
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={process.env.PUBLIC_URL + "/mission-vision"}
                            >
                              Mission & Vision
                            </Link>
                          </li>
                          <li>
                            <Link to={process.env.PUBLIC_URL + "/testimonials"}>
                              Testimonials
                            </Link>
                          </li>
                          <li>
                            {" "}
                            <Link
                              to={process.env.PUBLIC_URL + "/health-safety"}
                            >
                              Health & Safety
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={process.env.PUBLIC_URL + "/sustainability"}
                            >
                              Sustainability
                            </Link>
                          </li>
                          <li>
                            <Link to={process.env.PUBLIC_URL + "/smart-tech"}>
                              Smart Tech
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="footer-widget">
                      <h6 className="widget-title">
                      <Link
                              to={
                                process.env.PUBLIC_URL + "/services"
                              }
                            >
                        Services
                        </Link>
                        </h6>
                      <div className="footer-menu-link">
                        <ul className="list-unstyled">
                          <li>
                            <Link
                              to={
                                process.env.PUBLIC_URL + "/service/ifm-services"
                              }
                            >
                              IFM Services
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={
                                process.env.PUBLIC_URL +
                                "/service/hard-services"
                              }
                            >
                              Hard Services
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={
                                process.env.PUBLIC_URL +
                                "/service/soft-services"
                              }
                            >
                              Soft Services
                            </Link>
                          </li>
                          <li>
                            {" "}
                            <Link
                              to={
                                process.env.PUBLIC_URL +
                                "/service/security-services"
                              }
                            >
                              Security Services
                            </Link>
                          </li>
                          <li>
                            {" "}
                            <Link
                              to={
                                process.env.PUBLIC_URL +
                                "/service/specialized-services"
                              }
                            >
                              Specialized Services
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 ">
                    <div className="footer-widget ">
                      <h6 className="widget-title"><Link to={process.env.PUBLIC_URL + "/contact-us"}>
                              Contact
                            </Link></h6>
                      <div className="footer-menu-link">
                        <ul className="list-unstyled">
                          <li>
                            <Link to={process.env.PUBLIC_URL + "/contact-us#contact"}>
                              Contact Us
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={process.env.PUBLIC_URL + "/request-quote"}
                            >
                              Request a Quote
                            </Link>
                          </li>
                          <li>
                            <Link to={process.env.PUBLIC_URL + "/faqs"}>
                              FAQs
                            </Link>
                          </li>
                          <li>
                            {" "}
                            <Link to={process.env.PUBLIC_URL + "/careers"}>
                              Careers
                            </Link>
                          </li>
                          <li>
                            {" "}
                            <Link
                              to={process.env.PUBLIC_URL + "/cookie-policy"}
                            >
                              Cookie Policy
                            </Link>
                          </li>
                        </ul>
                        {/* <ul className="list-unstyled">
                        <li className="d-inline-flex phone-item">
                          <MdPhoneInTalk className="icon-right" />
                          <a href="tel:8008293">800 8293 (800 UCWF)</a>
                        </li>
                        <li className="d-md-inline-flex">
                          <MdEmail className="icon-right" size={20} />
                          <a href="mailto:info@ucwf.net">info@ucwf.net</a>
                        </li>
                        <li className="d-inline-flex">
                          <Globe className="icon-right" size={20}/>
                          <a href={"http://ucwf.net/"}>http://ucwf.net/</a>
                        </li>
                        <li  className="d-inline-flex">
                          {" "}
                          <MapPinHouse  className="icon-right" size={iconSize}/>
                          <Link to={process.env.PUBLIC_URL + "/"}>9th Floor, Prism Tower, Business Bay - Dubai,  UAE</Link>
                        </li>
                      </ul> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="footer-top">
          <div className="footer-social-link">
            <ul className="list-unstyled">
              <li>
                <Link to="https://facebook.com/">
                  <FaFacebookF />
                </Link>
              </li>
              <li>
                <Link to="https://www.pinterest.com/">
                  <FaInstagram />
                </Link>
              </li>
              <li>
                <Link to="https://www.linkedin.com/">
                  <FaLinkedin />
                </Link>
              </li>
            </ul>
          </div>
        </div> */}
          <div className="footer-bottom">
            <div className="row">
              <div className="col-md-6">
                <div className="footer-copyright">
                  <span className="copyright-text" style={{ fontSize: "14px" }}>
                    © {new Date().getFullYear()}. All rights reserved by{" "}
                    <a href="https://axilthemes.com/">UCWF</a>.
                  </span>
                </div>
              </div>
              <div className="col-md-6">
                <div className="footer-bottom-link">
                  <ul className="list-unstyled"></ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default FooterOne;
